import React, { useState, useEffect } from 'react'

export default function ReadingProgress() {
  const [pct, setPct] = useState(0)
  useEffect(() => {
    const onScroll = () => {
      const el  = document.documentElement
      const top = el.scrollTop || document.body.scrollTop
      const h   = el.scrollHeight - el.clientHeight
      setPct(h > 0 ? Math.min(100, (top / h) * 100) : 0)
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
  return (
    <div className="sp-progress">
      <div className="sp-progress__bar" style={{ width: `${pct}%` }} />
    </div>
  )
}
